"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostContextProvider = void 0;
const React = __importStar(require("react"));
const host_context_1 = require("./host-context");
const react_router_1 = require("react-router");
const HostContextProvider = ({ children, launcher }) => {
    const [context, setContext] = React.useState();
    const { runnerId, requestId } = (0, react_router_1.useParams)();
    React.useEffect(() => {
        let services;
        let mounted = true;
        const initializeServices = async () => {
            try {
                const result = launcher(runnerId, requestId);
                services = await Promise.resolve(result);
                if (mounted) {
                    setContext(services);
                }
                else {
                    services.guideDestroyers.forEach((d) => d());
                }
            }
            catch (e) {
                console.error('Failed to initialize host services', e);
            }
        };
        initializeServices();
        return () => {
            mounted = false;
            services?.guideDestroyers.forEach((d) => d());
        };
    }, []);
    return context ? (React.createElement(host_context_1.HostContext.Provider, { value: context },
        React.createElement("div", null, children))) : (React.createElement(React.Fragment, null));
};
exports.HostContextProvider = HostContextProvider;
